"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const MainListItem = /*#__PURE__*/_styledComponents.default.li.withConfig({
  displayName: "CarouselItems__MainListItem",
  componentId: "bufferapp-ui__sc-1p42epf-0"
})(["list-style:none;"]);
const CarouselItems = _ref => {
  let {
    children,
    currentSlideIndex
  } = _ref;
  const items = _react.default.Children.map(children, (child, index) => ( /*#__PURE__*/_react.default.createElement(MainListItem, {
    key: index,
    "aria-hidden": currentSlideIndex !== index
  }, child)));
  return items;
};
CarouselItems.propTypes = {
  children: _propTypes.default.node.isRequired,
  currentSlideIndex: _propTypes.default.number.isRequired
};
var _default = exports.default = CarouselItems;